import { memo } from 'react';
import Typography from '@material-ui/core/Typography';

interface BadgeProps {
  text: string;
  className?: string;
  icon?: React.ReactNode;
}

const Badge = memo(({ text, className = '', icon }: BadgeProps) => {
  const statusClassName = className.includes('pd-table-status-badge')
    ? text.toLowerCase() === 'failed'
      ? 'pd-table-status-badge-failed'
      : text.toLowerCase() === 'successful'
      ? 'pd-table-status-badge-successful'
      : text.toLowerCase() === 'stopped'
      ? 'pd-table-status-badge-stopped'
      : ''
    : '';
  const badgeClassName = `badge ${className} ${statusClassName}`.trim();

  return (
    <Typography component="span" className={badgeClassName}>
      {icon}
      {text}
    </Typography>
  );
});

export default Badge;
